import { render, staticRenderFns } from "./ChatOverlay.vue?vue&type=template&id=ae7b69fe&scoped=true"
import script from "./ChatOverlay.vue?vue&type=script&lang=js"
export * from "./ChatOverlay.vue?vue&type=script&lang=js"
import style0 from "./ChatOverlay.vue?vue&type=style&index=0&id=ae7b69fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b69fe",
  null
  
)

export default component.exports